import React from "react";
import { withStyles } from '@material-ui/core/styles';
import { FiberManualRecord } from '@material-ui/icons';
import Tooltip from "../../../common/StyledToolTip";
import appConstant from "../../../../appConstants";
import CheckViolation from "../../../../components/common/checkViolation";

const styles = theme => ({
    root:{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
        flexDirection: "column"
    },
    icon:{
        fontSize: theme.textFontSize,
        color: theme.rowViolationDotColor,
    },
    iconNew:{
        fontSize:  theme.textFontSize,
        color: theme.HeaderSelectedText,
    },
    warningIcon:{
        fontSize:  theme.textFontSize,
        color: theme.warningColor,
    },
    tooltipList:{
        listStyleType: 'none',
        padding: '0px',
        margin: '0px',
        fontSize: theme.textFontSize,
    }
});

function getViolationMessage (params, planDate) {
    let message = [];
    let warningMessages = [];
    let isNewBillsViolation = false;
    if(params.colDef?.gridTitle){
        switch(params.colDef.gridTitle){
            case appConstant.gridNames.RoutesGrid:
                if (params.data.routeName === appConstant.UNRTD_ROUTENAME) {
                    break;
                }
                if(CheckViolation.checkNewProsInRoute(params)){
                    message.push(CheckViolation.checkNewProsInRoute(params));
                    isNewBillsViolation = true;
                }else{
                    message.push(CheckViolation.checkNumServiceViolation(params));
                    message.push(CheckViolation.checkRouteLiftGateViolation(params));
                    message.push(CheckViolation.checkRouteProArrivingLate(params));
                    message.push(CheckViolation.checkEquipmentMatch(params));
                    message.push(CheckViolation.checkAnchorPointEquipmentMatch(params));
                    message.push(CheckViolation.checkClosedCustomerViolationForRouteStops(params.data));
                    params.context.enableFMECustomer && message.push(CheckViolation.checkNoFMERouteViolation(params));
                    message.push(CheckViolation.checkPSEViolation(params))
                    message.push(CheckViolation.checkHazmatAndFoodViolation(params))
                    warningMessages.push(CheckViolation.checkExtraTrailer(params));
                    message.push(CheckViolation.checkRouteHasHoldPro({data: params.data, context: params.context, gridName: "Route"}));
                }
                break;
            case appConstant.gridNames.StopsGrid:
                if(CheckViolation.checkNewProsInStop(params)){
                    message.push(CheckViolation.checkNewProsInStop(params));
                    isNewBillsViolation = true;
                }else{
                    message.push(CheckViolation.checkAppointmentMissed(params));
                    message.push(CheckViolation.checkPrepTimeGreaterThanStartTime({data: params.data, planDate: planDate}));
                    message.push(CheckViolation.checkEquipmentMatch(params));
                    message.push(CheckViolation.checkStopOrShipmentLiftGateViolation(params));
                    message.push(CheckViolation.checkAnchorPointEquipmentMatch(params));
                    message.push(CheckViolation.checkClosedCustomerViolation(params.data));
                    params.context.enableFMECustomer && message.push(CheckViolation.checkNoFMERouteStopViolation(params));
                    message.push(CheckViolation.checkRouteHasHoldPro({data: params.data, context: params.context, gridName: "Stop"}));
                }
                break;
            case appConstant.gridNames.IBShipmentsGrid:
                if(CheckViolation.checkProIsNew(params)){
                    message.push(CheckViolation.checkProIsNew(params));
                    isNewBillsViolation = true;
                }else{
                    message.push(CheckViolation.checkRouteStartTimeViolation({data: params.data, planDate: planDate}));
                    message.push(CheckViolation.checkLocationGeoCoded({data: params.data}));
                    message.push(CheckViolation.checkStopOrShipmentLiftGateViolation(params));
                    message.push(CheckViolation.checkClosedCustomerViolation(params.data));
                    params.context.enableHoldPros && message.push(CheckViolation.checkIsHoldPro(params.data));
                    params.context.enableFMECustomer && message.push(CheckViolation.checkNoFMEShipmentViolation(params));
                }
                break;
            case appConstant.gridNames.DispatchedDriverGrid:
                if(CheckViolation.checkDriverHasDelayStops(params)){
                    message.push(CheckViolation.checkDriverHasDelayStops(params));
                }
                break;
            case appConstant.gridNames.CustomerGrid:
                if(CheckViolation.checkLocationGeoCoded({data: params.data})){
                    message.push(CheckViolation.checkLocationGeoCoded({data: params.data}));
                }
                break;
            case appConstant.gridNames.PriorityShipmentsGrid:
                if(CheckViolation.checkDelayedPriorityShipment({data: params.data})){
                  message.push(CheckViolation.checkDelayedPriorityShipment({data: params.data}));
                }
                break;
        }
    }
    message = message.filter(Boolean);
    warningMessages = warningMessages.filter(Boolean);
    return { message, isNewBillsViolation, warningMessages}
}

function getPlanDate(params){
    return params.context?.planDate || null;
}

function formatTooltip(messages, tooltipClass) {
    if(messages && messages.length > 0 ){
        const formattedMessage = messages.map((element, index) => (<li key={index}>{element}</li>));
        return (<ul className={tooltipClass}>{formattedMessage}</ul>);
    }
    return '';
}

const DotRenderer = params => {
    const { classes } = params;
    const {message, isNewBillsViolation, warningMessages} = getViolationMessage(params, getPlanDate(params));
    const formattedMessage = formatTooltip(message, classes.tooltipList);
    return (<div className={classes.root}>
        {
            message.length > 0 ? (<Tooltip title={formattedMessage}>
                                    <FiberManualRecord className={isNewBillsViolation ? classes.iconNew : classes.icon}/>
                                  </Tooltip>)
                                  : ''
        }
        {
             warningMessages.length > 0 ? (<Tooltip title={formatTooltip(warningMessages, classes.tooltipList)}>
                <FiberManualRecord className={classes.warningIcon}/>
              </Tooltip>)
              : ''
        }
    </div>
    )
}

export default withStyles(styles)(DotRenderer);
